import { numberWithCommas } from 'common/formatters';

export default function makeNumbersRange(lowerBound, upperBound) {
  if (upperBound && lowerBound !== upperBound) {
    return `${numberWithCommas(lowerBound)} - ${numberWithCommas(upperBound)}`;
  }
  return `${numberWithCommas(lowerBound)}`;
}
